<vb-theme-styles></vb-theme-styles>

<div class="text-center centered-text-block" [hidden]="!StateChangeStatus.error">
	<h3 class="centered-text-block-content">
		{{ 'Video_Playback_UnhandledPlaybackError' | translate }}
	</h3>
</div>

<vb-loading-spinner [block]="true" [size]="'medium'" [hidden]="!StateChangeStatus?.changing">
</vb-loading-spinner>

<div class="height-full" ui-view></div>
